import {ThemeDefinition} from '@volkswagen-onehub/components-core';
import {NaturalLanguageFeatureAppTheme} from '@volkswagen-onehub/whitelabel-e-mobility-commons';

export function createNaturalLanguageFeatureAppThemeV26(
  theme: ThemeDefinition
): NaturalLanguageFeatureAppTheme {
  return {
    colors: {
      app: {
        background: theme.colors.background.primary,
      },
      outputArea: {
        background: theme.colors.content.primary,
      },
    },
    spacing: {
      appLayout: {
        blockGap: theme.size.grid001,
      },
      contentLayout: {
        inlineStart: 'var(--content-layout-inline-start)',
        inlineEnd: 'var(--content-layout-inline-end)',
      },
      inputSectionLayout: {
        blockStart: theme.size.dynamic0130,
        blockEnd: theme.size.dynamic0130,
      },
    },
    elements: {
      inputArea: {
        gap: theme.size.static350,
        textGap: theme.size.static200,
        selectWidth: '240px',
      },
      outputArea: {
        padding: theme.size.dynamic0100,
        result: {
          gap: theme.size.static350,
        },
        borderRadius: theme.size.borderRadius.cardS,
      },
      efficiencyDataSeparator: '\u00a0• ',
    },
  };
}
